import { QUERY_KEYS } from 'api/query-keys';
import { documentsService } from 'hq/services';
import { SignDocumentDtoRequest } from 'hq/services/documents-service.types';
import { useMutation, useQueryClient } from 'react-query';

type SignDocumentParams = {
  documentId: string;
  dto: SignDocumentDtoRequest;
};

export const useSignDocument = () => {
  const mutationFn = async ({ documentId, dto }: SignDocumentParams) =>
    await documentsService.signDocument(documentId, dto);

  const queryClient = useQueryClient();

  return useMutation(mutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.documents());
    },
  });
};
